// Members
import ReviewerManagement from "@/views/ReviewerView/ReviewerManagement.vue";
import ReviewerAssignment from "@/views/ReviewerView/ReviewerAssignment.vue";

import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

const reviewersMenu = {
  path: "/reviewers",
  component: DashboardLayout,
  name: "심사자 관리",
  children: [
    {
      path: "managements",
      name: "reviewer-management",
      components: { default: ReviewerManagement },
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "심사자 관리 > 심사자 추가 및 삭제",
      },
    },
    {
      path: "assignments",
      name: "reviewer-assignment",
      components: { default: ReviewerAssignment },
      meta: {
        requiresAuth: true,
        requiredRoles: ["editor", "master"],
        title: "심사자 관리 > 심사자 배정",
      },
    },
  ],
};

export default reviewersMenu;
